var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessWriting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.5064 62.2812V9.78125C71.5064 4.87687 67.8868 1.03125 63.2708 1.03125C58.6547 1.03125 55.0352 4.87687 55.0352 9.78125V62.2812L63.2708 71.0312L71.5064 62.2812Z",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0352 18.5312H71.5064",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.271 71.0312H9.73952C7.5553 71.0312 5.46054 70.1094 3.91606 68.4684C2.37158 66.8275 1.50391 64.6019 1.50391 62.2812C1.50391 59.9606 2.37158 57.735 3.91606 56.0941C5.46054 54.4531 7.5553 53.5312 9.73952 53.5312H26.2108C28.395 53.5312 30.4897 52.6094 32.0342 50.9684C33.5787 49.3275 34.4464 47.1019 34.4464 44.7812C34.4464 42.4606 33.5787 40.235 32.0342 38.5941C30.4897 36.9531 28.395 36.0312 26.2108 36.0312H13.8573",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessWriting);
export default __webpack_public_path__ + "static/media/business-writing.a48703e43702a48511af0bfa6b1ea075.svg";
export { ForwardRef as ReactComponent };